<template>
  <div class="channel-detail-page" v-loading="loading">
    <template v-if="detail.channel && detail.channel.id">
      <div class="detail-header">
        <div class="detail-header__main">
          <h2>{{ detail.channel.nickname || `渠道 #${detail.channel.id}` }}</h2>
          <p>
            APP：{{
              detail.channel.app && detail.channel.app.app_name
                ? detail.channel.app.app_name
                : "--"
            }}
          </p>
        </div>
        <div class="detail-header__meta">
          <el-tag :type="Number(configForm.is_open) === 1 ? 'success' : 'info'">
            {{ Number(configForm.is_open) === 1 ? "开启" : "关闭" }}
          </el-tag>
          <el-tag effect="plain">渠道 ID：{{ detail.channel.id }}</el-tag>
        </div>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="主数据" name="base">
          <el-card shadow="never" class="detail-card">
            <el-form
              ref="baseFormRef"
              class="mobile-stack-form"
              :model="baseForm"
              :rules="baseRules"
              label-width="120px"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="渠道 ID">
                    <el-input :value="baseForm.id" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP ID">
                    <el-input :value="baseForm.app_id" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="渠道名称" prop="nickname">
                    <el-input v-model.trim="baseForm.nickname" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP 名称">
                    <el-input
                      :value="
                        detail.channel.app && detail.channel.app.app_name
                          ? detail.channel.app.app_name
                          : ''
                      "
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP 编码">
                    <el-input
                      :value="
                        detail.channel.app && detail.channel.app.app_code
                          ? detail.channel.app.app_code
                          : ''
                      "
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-input
                      :value="$fnc.getTimeFormat(detail.channel.created_time, 'ymdhms')"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="更新时间">
                    <el-input
                      :value="$fnc.getTimeFormat(detail.channel.updated_time, 'ymdhms')"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="detail-actions">
              <el-button type="primary" :loading="baseSaving" @click="saveBase">
                保存主数据
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道配置" name="config">
          <el-card shadow="never" class="detail-card">
            <div class="config-banner">
              当前保存的是渠道配置本身，不会影响 APP 基础配置。
            </div>
            <div class="config-toolbar">
              <el-button
                type="primary"
                plain
                icon="el-icon-copy-document"
                @click="openCopyConfigDialog"
              >
                从其他渠道复制
              </el-button>
            </div>
            <el-form
              ref="configFormRef"
              class="mobile-stack-form"
              :model="configForm"
              :rules="configRules"
              label-width="140px"
            >
              <div class="config-section">
                <div class="config-section__title">奖励与投放</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="佣金比例">
                      <el-input v-model.trim="configForm.amount_number" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="推荐比例">
                      <el-input
                        v-model.trim="configForm.recommend_number"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最大广告数">
                      <el-input v-model.trim="configForm.max_ad" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最大 ECPM">
                      <el-input v-model.trim="configForm.max_money" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最小金额">
                      <el-input v-model.trim="configForm.min_amount" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最小金额数量">
                      <el-input
                        v-model.trim="configForm.min_amount_num"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="激励前插屏">
                      <el-switch
                        v-model="configForm.reward_pre_interstitial_open"
                        active-value="1"
                        inactive-value="0"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="激励后插屏">
                      <el-switch
                        v-model="configForm.reward_post_interstitial_open"
                        active-value="1"
                        inactive-value="0"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="config-section">
                <div class="config-section__title">下载与登录</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="APK 地址">
                      <el-input v-model.trim="configForm.apk_url" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="渠道开关">
                      <el-select v-model="configForm.is_open" style="width: 100%">
                        <el-option label="开启" value="1" />
                        <el-option label="关闭" value="0" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="页面模板">
                      <el-select
                        v-model="configForm.template_type"
                        style="width: 100%"
                        placeholder="请选择页面模板"
                      >
                        <el-option
                          v-for="item in templateOptions"
                          :key="item.value"
                          :label="item.label || item.value"
                          :value="item.value"
                        >
                          <span>{{ item.label || item.value }}</span>
                          <span v-if="item.description" class="template-option__desc">
                            {{ item.description }}
                          </span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="登录方式">
                      <el-select
                        v-model="configForm.login_type"
                        multiple
                        style="width: 100%"
                        placeholder="请选择登录方式"
                      >
                        <el-option label="微信登录" value="0" />
                        <el-option label="游客登录" value="1" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="config-section">
                <div class="config-section__title">提现配置</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="提现入口">
                      <el-select v-model="configForm.open_withdraw" style="width: 100%">
                        <el-option label="开启" value="1" />
                        <el-option label="关闭" value="0" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="提现方式">
                      <el-select
                        v-model="configForm.withdraw_type"
                        multiple
                        style="width: 100%"
                        placeholder="请选择提现方式"
                      >
                        <el-option label="支付宝" value="0" />
                        <el-option label="微信" value="1" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="提现金额表">
                      <el-button type="primary" plain @click="openAmountOptionDialog">
                        配置金额档位
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="config-section">
                <div class="config-section__title">时序控制</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="关闭等待时间">
                      <el-input v-model.trim="configForm.close_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="拉起激励等待">
                      <el-input
                        v-model.trim="configForm.open_reward_time"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开屏超时时间">
                      <el-input v-model.trim="configForm.splash_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="红包打开间隔">
                      <el-input v-model.trim="configForm.open_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="信息流刷新间隔">
                      <el-input v-model.trim="configForm.info_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏间隔" prop="interstitial_time">
                      <el-input
                        v-model.trim="configForm.interstitial_time"
                        type="number"
                        min="1"
                        step="1"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏次数" prop="interstitial_num">
                      <el-input
                        v-model.trim="configForm.interstitial_num"
                        type="number"
                        min="1"
                        step="1"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏定时开关" prop="Interstitial_open">
                      <el-select
                        v-model="configForm.Interstitial_open"
                        style="width: 100%"
                        @change="$refs.configFormRef.clearValidate(['interstitial_time', 'interstitial_num'])"
                      >
                        <el-option label="开启" value="1" />
                        <el-option label="关闭" value="0" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>

            <div class="detail-actions">
              <el-button type="primary" :loading="configSaving" @click="saveConfig">
                保存渠道配置
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道规则" name="rules">
          <el-card shadow="never" class="detail-card">
            <el-tabs v-model="ruleTab" class="rule-tabs">
              <el-tab-pane label="登录规则" name="1">
                <channel-rules
                  :key="`login-${ruleRefreshKey}`"
                  :channel-id="channelId"
                  type="1"
                />
              </el-tab-pane>
              <el-tab-pane label="拉广规则" name="2">
                <channel-rules
                  :key="`ad-${ruleRefreshKey}`"
                  :channel-id="channelId"
                  type="2"
                />
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="定时风控" name="risk-task">
          <el-card shadow="never" class="detail-card">
            <div class="risk-task-summary">
              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">系统任务</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_task && detail.channel_risk_task.name
                      ? detail.channel_risk_task.name
                      : "尚未自动创建"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_task
                      ? `状态：${formatTaskStatus(detail.channel_risk_task.status)}`
                      : "新增第一条策略后会自动创建"
                  }}
                </div>
              </div>

              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">系统调度器</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_scheduler &&
                    detail.channel_risk_scheduler.name
                      ? detail.channel_risk_scheduler.name
                      : "尚未自动创建"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_scheduler
                      ? `模块：${detail.channel_risk_scheduler.handler_module || "--"}`
                      : "由系统自动生成"
                  }}
                </div>
              </div>

              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">最近运行</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_latest_log
                      ? formatRunStatus(detail.channel_risk_latest_log.status)
                      : "暂无运行记录"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_latest_log &&
                    detail.channel_risk_latest_log.finished_at
                      ? formatTime(detail.channel_risk_latest_log.finished_at)
                      : "任务运行后会显示"
                  }}
                </div>
              </div>
            </div>

            <div class="risk-task-toolbar">
              <div class="risk-task-toolbar__hint">
                策略按渠道维护，系统任务和调度器由后端自动生成。
              </div>
              <el-button type="primary" size="mini" @click="openPolicyDialog()">
                新增策略
              </el-button>
            </div>

            <el-table
              v-if="!isMobileViewport"
              :data="detail.channel_risk_policies || []"
              border
              stripe
              empty-text="暂无策略"
            >
              <el-table-column prop="name" label="策略名称" min-width="160" />
              <el-table-column label="策略类型" min-width="140" align="center">
                <template slot-scope="{ row }">
                  {{ getPolicyTypeLabel(row.policy_type) }}
                </template>
              </el-table-column>
              <el-table-column label="启用" width="90" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="Number(row.enabled) === 1 ? 'success' : 'info'">
                    {{ Number(row.enabled) === 1 ? "启用" : "停用" }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="priority" label="优先级" width="90" align="center" />
              <el-table-column label="参数摘要" min-width="240">
                <template slot-scope="{ row }">
                  {{ getPolicyConfigSummary(row) }}
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" min-width="180" />
              <el-table-column
                label="操作"
                :width="isMobileViewport ? 76 : 150"
                align="center"
                fixed="right"
              >
                <template slot-scope="{ row }">
                  <responsive-actions
                    :items="policyRowActions"
                    @select="handlePolicyRowAction($event, row)"
                  />
                </template>
              </el-table-column>
            </el-table>
            <mobile-record-list
              v-else
              :rows="detail.channel_risk_policies || []"
              :title="getMobilePolicyTitle"
              :subtitle="getMobilePolicySubtitle"
              :fields="mobilePolicyFields"
              :actions="policyRowActions"
              @action="handlePolicyRowAction"
            />
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道用户" name="users">
          <el-card shadow="never" class="detail-card">
            <channel-users :channel-id="channelId" />
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>

    <el-dialog
      title="复制渠道配置和规则"
      :visible.sync="copyConfigDialogVisible"
      width="520px"
      @closed="resetCopyConfigDialog"
    >
      <el-alert
        title="支持跨 APP 复制。复制后将覆盖当前渠道配置和全部渠道规则，渠道主数据及 APP 归属不会变更。"
        type="warning"
        :closable="false"
        show-icon
        class="copy-config-alert"
      />
      <el-form
        ref="copyConfigFormRef"
        :model="copyConfigForm"
        :rules="copyConfigRules"
        label-width="100px"
      >
        <el-form-item label="源渠道" prop="copy_id">
          <el-select
            v-model="copyConfigForm.copy_id"
            filterable
            style="width: 100%"
            placeholder="请选择源渠道"
            :loading="copySourceLoading"
            :disabled="copySourceLoading"
          >
            <el-option
              v-for="item in copySourceChannels"
              :key="item.id"
              :label="formatCopySourceLabel(item)"
              :value="String(item.id)"
            />
          </el-select>
          <div v-if="!copySourceLoading && !copySourceChannels.length" class="form-tip">
            没有其他可复制的渠道
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyConfigDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="copyConfigSaving"
          :disabled="!copySourceChannels.length"
          @click="copyChannelConfig"
        >
          确认复制
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提现金额档位"
      :visible.sync="amountOptionDialogVisible"
      width="760px"
      @open="loadAmountOptions"
      @closed="resetAmountOptionForm"
    >
      <el-form
        ref="amountOptionFormRef"
        :model="amountOptionForm"
        label-width="110px"
        size="small"
      >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="金额（元）">
              <el-input
                v-model.trim="amountOptionForm.amount_yuan"
                type="number"
                placeholder="例：1.00"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目单位">
              <el-input
                v-model.trim="amountOptionForm.money"
                type="number"
                placeholder="100000 = 1元"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input-number
                v-model="amountOptionForm.sort"
                :min="0"
                :max="9999"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="amountOptionForm.status" style="width: 100%">
                <el-option label="启用" value="1" />
                <el-option label="停用" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label=" ">
              <el-button type="primary" :loading="amountOptionSaving" @click="saveAmountOption">
                {{ editingAmountOption ? "保存档位" : "新增档位" }}
              </el-button>
              <el-button @click="resetAmountOptionForm">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        v-if="!isMobileViewport"
        :data="amountOptions"
        border
        stripe
        v-loading="amountOptionLoading"
        empty-text="暂无金额档位"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="金额" min-width="160">
          <template slot-scope="{ row }">
            {{ formatAmountOption(row) }}
          </template>
        </el-table-column>
        <el-table-column prop="money" label="项目单位" min-width="140" />
        <el-table-column prop="sort" label="排序" width="90" align="center" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="String(row.status) === '1' ? 'success' : 'info'">
              {{ String(row.status) === "1" ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :width="isMobileViewport ? 76 : 170"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <responsive-actions
              :items="amountOptionRowActions"
              @select="handleAmountOptionRowAction($event, row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <mobile-record-list
        v-else
        :rows="amountOptions"
        :loading="amountOptionLoading"
        :title="getMobileAmountTitle"
        :subtitle="getMobileAmountSubtitle"
        :fields="mobileAmountOptionFields"
        :actions="amountOptionRowActions"
        @action="handleAmountOptionRowAction"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="amountOptionDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="editingPolicy ? '编辑风控策略' : '新增风控策略'"
      :visible.sync="policyDialogVisible"
      width="760px"
      @closed="resetPolicyDialog"
    >
      <el-form
        ref="policyFormRef"
        :model="policyForm"
        :rules="policyRules"
        label-width="120px"
        size="small"
      >
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="策略类型" prop="policy_type">
              <el-select
                v-model="policyForm.policy_type"
                placeholder="请选择策略类型"
                style="width: 100%"
                :disabled="editingPolicy"
                @change="handlePolicyTypeChange"
              >
                <el-option
                  v-for="item in policyTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="策略名称" prop="name">
              <el-input
                v-model.trim="policyForm.name"
                placeholder="请输入策略名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-switch
                v-model="policyForm.enabled"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级" prop="priority">
              <el-input-number
                v-model="policyForm.priority"
                :min="0"
                :max="9999"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="currentPolicySchema">
          <div
            v-for="section in currentPolicySchema.sections || []"
            :key="section.title"
            class="policy-section"
          >
            <div class="policy-section__title">{{ section.title }}</div>
            <el-row :gutter="16">
              <el-col
                v-for="field in section.fields || []"
                v-show="shouldShowPolicyField(field, policyForm.policy_config)"
                :key="field.key"
                :span="12"
              >
                <el-form-item
                  :label="field.label"
                  :prop="`policy_config.${field.key}`"
                  :rules="buildDynamicFieldRules(field)"
                >
                  <el-input
                    v-if="field.type === 'input'"
                    v-model="policyForm.policy_config[field.key]"
                    :placeholder="field.placeholder || `请输入${field.label}`"
                  />
                  <el-input-number
                    v-else-if="field.type === 'number'"
                    v-model="policyForm.policy_config[field.key]"
                    :min="field.min !== undefined ? field.min : 0"
                    :max="field.max !== undefined ? field.max : 99999999"
                    style="width: 100%"
                  />
                  <el-select
                    v-else-if="field.type === 'select'"
                    v-model="policyForm.policy_config[field.key]"
                    style="width: 100%"
                    :placeholder="field.placeholder || `请选择${field.label}`"
                  >
                    <el-option
                      v-for="option in field.options || []"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    />
                  </el-select>
                  <el-switch
                    v-else-if="field.type === 'switch'"
                    v-model="policyForm.policy_config[field.key]"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </template>

        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="policyForm.remark"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="policyDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="policySaving" @click="savePolicy">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChannelRules from "@/components/app/components/Rules.vue";
import ChannelUsers from "@/components/app/components/UserAd.vue";
import {
  getPolicyConfigSummary,
  getPolicyTypeLabel,
  getTaskRunStatusLabel,
  mergePolicyDefaultConfig,
  normalizePolicyConfigValue,
  shouldShowPolicyField,
} from "@/utils/riskTask";
import responsiveMixin from "@/mixins/responsive";

const defaultConfigForm = () => ({
  close_time: "",
  open_reward_time: "",
  max_ad: "",
  amount_number: "",
  recommend_number: "",
  apk_url: "",
  is_open: "0",
  template_type: "",
  open_withdraw: "0",
  withdraw_type: [],
  splash_time: "",
  open_time: "",
  login_type: [],
  min_amount: "",
  min_amount_num: "",
  max_money: "",
  interstitial_time: "",
  Interstitial_open: "0",
  reward_pre_interstitial_open: "0",
  reward_post_interstitial_open: "0",
  info_time: "",
  interstitial_num: "",
});

const defaultPolicyForm = (channelId = "") => ({
  id: "",
  channel_id: channelId,
  policy_type: "",
  name: "",
  enabled: 1,
  priority: 100,
  remark: "",
  policy_config: {},
});

const defaultAmountOptionForm = (channelId = "", appId = "") => ({
  id: "",
  app_id: appId,
  channel_id: channelId,
  amount_yuan: "",
  money: "",
  sort: 0,
  status: "1",
});

export default {
  mixins: [responsiveMixin],
  components: {
    ChannelRules,
    ChannelUsers,
  },
  data() {
    const validateTimedPositiveInteger = (label) => (rule, value, callback) => {
      if (this.configForm.Interstitial_open !== "1") {
        callback();
        return;
      }
      const normalized = String(value === undefined || value === null ? "" : value).trim();
      if (!/^\d+$/.test(normalized) || Number(normalized) <= 0) {
        callback(new Error(`定时插屏开启时，${label}必须为正整数`));
        return;
      }
      callback();
    };

    return {
      loading: false,
      baseSaving: false,
      configSaving: false,
      copySourceLoading: false,
      copyConfigSaving: false,
      policySaving: false,
      amountOptionLoading: false,
      amountOptionSaving: false,
      policyDialogVisible: false,
      copyConfigDialogVisible: false,
      amountOptionDialogVisible: false,
      editingPolicy: false,
      editingAmountOption: false,
      activeTab: "base",
      ruleTab: "1",
      ruleRefreshKey: 0,
      copySourceChannels: [],
      copyConfigForm: {
        copy_id: "",
      },
      policyOptionsMeta: {
        policy_types: [],
        form_schemas: {},
      },
      templateOptions: [],
      templateDefaultValue: "",
      detail: {
        channel: null,
        channel_config: null,
        channel_rules: [],
        channel_risk_policies: [],
        channel_risk_task: null,
        channel_risk_scheduler: null,
        channel_risk_latest_log: null,
      },
      baseForm: {
        id: "",
        app_id: "",
        nickname: "",
      },
      configForm: defaultConfigForm(),
      policyForm: defaultPolicyForm(),
      amountOptions: [],
      amountOptionForm: defaultAmountOptionForm(),
      baseRules: {
        nickname: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
      },
      configRules: {
        interstitial_time: [
          { validator: validateTimedPositiveInteger("插屏间隔"), trigger: "blur" },
        ],
        interstitial_num: [
          { validator: validateTimedPositiveInteger("插屏次数"), trigger: "blur" },
        ],
      },
      copyConfigRules: {
        copy_id: [{ required: true, message: "请选择源渠道", trigger: "change" }],
      },
      policyRules: {
        policy_type: [{ required: true, message: "请选择策略类型", trigger: "change" }],
        name: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
        priority: [{ required: true, message: "请输入优先级", trigger: "change" }],
      },
    };
  },
  computed: {
    mobilePolicyFields() {
      return [
        { label: "策略类型", value: (row) => this.getPolicyTypeLabel(row.policy_type) },
        {
          label: "启用状态",
          value: (row) => (Number(row.enabled) === 1 ? "启用" : "停用"),
          tag: true,
          tagType: (row) => (Number(row.enabled) === 1 ? "success" : "info"),
        },
        { label: "优先级", key: "priority" },
        { label: "参数摘要", value: (row) => this.getPolicyConfigSummary(row) },
        { label: "策略ID", key: "id", summary: false },
        { label: "备注", key: "remark", summary: false },
      ];
    },
    mobileAmountOptionFields() {
      return [
        { label: "金额", value: (row) => this.formatAmountOption(row) },
        { label: "项目单位", key: "money" },
        { label: "排序", key: "sort" },
        {
          label: "状态",
          value: (row) => (String(row.status) === "1" ? "启用" : "停用"),
          tag: true,
          tagType: (row) => (String(row.status) === "1" ? "success" : "info"),
        },
        { label: "档位ID", key: "id", summary: false },
      ];
    },
    amountOptionRowActions() {
      return [
        { key: "edit", label: "编辑", type: "primary" },
        { key: "delete", label: "删除", type: "danger" },
      ];
    },
    policyRowActions() {
      return [
        { key: "edit", label: "编辑", type: "primary" },
        { key: "delete", label: "删除", type: "danger" },
      ];
    },
    channelId() {
      return this.$route.query.id || "";
    },
    policyTypeOptions() {
      return this.policyOptionsMeta.policy_types || [];
    },
    currentPolicyMeta() {
      const schemas = this.policyOptionsMeta.form_schemas || {};
      return schemas[this.policyForm.policy_type] || null;
    },
    currentPolicySchema() {
      return this.currentPolicyMeta ? this.currentPolicyMeta.form_schema : null;
    },
  },
  methods: {
    getMobilePolicyTitle(row) {
      return row.name || `策略 #${row.id}`;
    },
    getMobilePolicySubtitle(row) {
      return `策略ID ${row.id}`;
    },
    getMobileAmountTitle(row) {
      return this.formatAmountOption(row);
    },
    getMobileAmountSubtitle(row) {
      return `档位ID ${row.id}`;
    },
    handleAmountOptionRowAction(key, row) {
      if (key === "edit") this.editAmountOption(row);
      if (key === "delete") this.deleteAmountOption(row);
    },
    handlePolicyRowAction(key, row) {
      if (key === "edit") this.openPolicyDialog(row);
      if (key === "delete") this.deletePolicy(row);
    },
    getPolicyTypeLabel,
    getPolicyConfigSummary,
    shouldShowPolicyField,
    fillForms(data = {}) {
      const channel = data.channel || {};
      const channelConfig = data.channel_config || {};

      this.detail = {
        channel,
        channel_config: channelConfig,
        channel_rules: Array.isArray(data.channel_rules) ? data.channel_rules : [],
        channel_risk_policies: Array.isArray(data.channel_risk_policies)
          ? data.channel_risk_policies
          : [],
        channel_risk_task: data.channel_risk_task || null,
        channel_risk_scheduler: data.channel_risk_scheduler || null,
        channel_risk_latest_log: data.channel_risk_latest_log || null,
      };

      this.baseForm = {
        id: channel.id || "",
        app_id: channel.app_id || "",
        nickname: channel.nickname || "",
      };

      this.configForm = {
        ...defaultConfigForm(),
        ...channelConfig,
        reward_pre_interstitial_open:
          channelConfig.reward_pre_interstitial_open === "1" ? "1" : "0",
        reward_post_interstitial_open:
          channelConfig.reward_post_interstitial_open === "1" ? "1" : "0",
        template_type: channelConfig.template_type || this.templateDefaultValue || "",
        login_type:
          channelConfig.login_type !== undefined &&
          channelConfig.login_type !== null &&
          channelConfig.login_type !== ""
            ? String(channelConfig.login_type)
                .split("@")
                .filter(Boolean)
            : [],
        withdraw_type:
          channelConfig.withdraw_type !== undefined &&
          channelConfig.withdraw_type !== null &&
          channelConfig.withdraw_type !== ""
            ? String(channelConfig.withdraw_type)
                .split("@")
                .filter(Boolean)
            : [],
      };
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
    formatTaskStatus(status) {
      return getTaskRunStatusLabel(status);
    },
    formatRunStatus(status) {
      return getTaskRunStatusLabel(status);
    },
    formatAmountOption(row) {
      if (row.amount_yuan !== undefined && row.amount_yuan !== null && row.amount_yuan !== "") {
        return `${Number(row.amount_yuan).toFixed(2)} 元`;
      }
      return `${(Number(row.money || 0) / 100000).toFixed(2)} 元`;
    },
    openAmountOptionDialog() {
      this.amountOptionDialogVisible = true;
    },
    async loadAmountOptions() {
      if (!this.channelId) {
        return;
      }

      this.amountOptionLoading = true;
      try {
        const data = await this.$api.getPayouts.getMoneyList({
          channel_id: this.channelId,
        });
        this.amountOptions = Array.isArray(data.data) ? data.data : [];
      } finally {
        this.amountOptionLoading = false;
      }
    },
    editAmountOption(row) {
      this.editingAmountOption = true;
      this.amountOptionForm = {
        ...defaultAmountOptionForm(this.channelId, this.baseForm.app_id),
        ...row,
        amount_yuan:
          row.amount_yuan !== undefined && row.amount_yuan !== null
            ? String(row.amount_yuan)
            : "",
        money:
          row.money !== undefined && row.money !== null
            ? String(Number(row.money).toFixed(0))
            : "",
        sort: Number(row.sort || row.index || 0),
        status: row.status === undefined || row.status === null ? "1" : String(row.status),
      };
    },
    resetAmountOptionForm() {
      this.editingAmountOption = false;
      this.amountOptionForm = defaultAmountOptionForm(this.channelId, this.baseForm.app_id);
    },
    async saveAmountOption() {
      const amountYuan = this.amountOptionForm.amount_yuan !== ""
        ? Number(this.amountOptionForm.amount_yuan)
        : 0;
      const rawMoney = amountYuan > 0
        ? Math.floor(amountYuan * 100000)
        : Math.floor(Number(this.amountOptionForm.money || 0));

      if (!rawMoney || rawMoney <= 0) {
        this.$message.warning("请输入提现金额");
        return;
      }

      this.amountOptionSaving = true;
      try {
        const payload = {
          id: this.amountOptionForm.id,
          app_id: this.baseForm.app_id,
          channel_id: this.channelId,
          money: rawMoney,
          amount_yuan: (rawMoney / 100000).toFixed(2),
          sort: this.amountOptionForm.sort,
          status: this.amountOptionForm.status,
        };
        const data = this.editingAmountOption
          ? await this.$api.getPayouts.postSaveMoney(payload)
          : await this.$api.getPayouts.postAddMoney(payload);
        if (data.code === 200) {
          this.$message.success(this.editingAmountOption ? "金额档位已保存" : "金额档位已新增");
          this.resetAmountOptionForm();
          await this.loadAmountOptions();
        }
      } finally {
        this.amountOptionSaving = false;
      }
    },
    deleteAmountOption(row) {
      this.$confirm(`确认删除 ${this.formatAmountOption(row)} 档位吗？`, "删除金额档位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const data = await this.$api.getPayouts.delMoney({ id: row.id });
          if (data.code === 200) {
            this.$message.success("金额档位已删除");
            await this.loadAmountOptions();
          }
        })
        .catch(() => {});
    },
    async getPolicyOptions() {
      const data = await this.$api.getChannel.getChannelRiskPolicyOptions();
      const payload = data.data && !Array.isArray(data.data) ? data.data : {};
      this.policyOptionsMeta = {
        policy_types: Array.isArray(payload.policy_types) ? payload.policy_types : [],
        form_schemas: payload.form_schemas || {},
      };
    },
    async getTemplateOptions() {
      const data = await this.$api.getChannel.getChannelTemplateOptions();
      const payload = data.data || {};
      this.templateOptions = Array.isArray(payload.list) ? payload.list : [];
      this.templateDefaultValue = payload.default_value || "";

      if (!this.configForm.template_type && this.templateDefaultValue) {
        this.configForm.template_type = this.templateDefaultValue;
      }
    },
    async getInfo() {
      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelInfo({
          id: this.channelId,
        });
        this.fillForms(data.data || {});
      } finally {
        this.loading = false;
      }
    },
    async openCopyConfigDialog() {
      this.copyConfigDialogVisible = true;
      this.copySourceLoading = true;
      try {
        const data = await this.$api.getChannel.getChannelList({});
        this.copySourceChannels = (Array.isArray(data.data) ? data.data : []).filter(
          (item) => String(item.id) !== String(this.channelId)
        );
      } finally {
        this.copySourceLoading = false;
      }
    },
    resetCopyConfigDialog() {
      this.copyConfigForm = {
        copy_id: "",
      };
      this.copySourceChannels = [];
      this.copyConfigSaving = false;
      if (this.$refs.copyConfigFormRef) {
        this.$refs.copyConfigFormRef.clearValidate();
      }
    },
    formatCopySourceLabel(channel) {
      const appName = channel.app && channel.app.app_name
        ? channel.app.app_name
        : `APP #${channel.app_id}`;
      const channelName = channel.nickname || "未命名渠道";
      return `${appName} / ${channelName}（渠道 ID：${channel.id}）`;
    },
    async copyChannelConfig() {
      const valid = await new Promise((resolve) => {
        this.$refs.copyConfigFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      const sourceChannel = this.copySourceChannels.find(
        (item) => String(item.id) === String(this.copyConfigForm.copy_id)
      );
      const sourceName = sourceChannel
        ? this.formatCopySourceLabel(sourceChannel)
        : `渠道 #${this.copyConfigForm.copy_id}`;

      try {
        await this.$confirm(
          `确认使用“${sourceName}”覆盖当前渠道的配置和全部规则吗？`,
          "确认复制",
          {
            confirmButtonText: "确认复制",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
      } catch (error) {
        return;
      }

      this.copyConfigSaving = true;
      try {
        const data = await this.$api.getChannel.copyChannelConfig({
          id: this.channelId,
          copy_id: this.copyConfigForm.copy_id,
        });
        if (data.code === 200) {
          this.$message.success("渠道配置和规则复制成功");
          this.copyConfigDialogVisible = false;
          await this.getInfo();
          this.ruleRefreshKey += 1;
        }
      } finally {
        this.copyConfigSaving = false;
      }
    },
    async saveBase() {
      const valid = await new Promise((resolve) => {
        this.$refs.baseFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.baseSaving = true;
      try {
        const data = await this.$api.getChannel.saveChannel({
          id: this.baseForm.id,
          nickname: this.baseForm.nickname,
        });
        if (data.code === 200) {
          this.$message.success("渠道主数据保存成功");
          this.getInfo();
        }
      } finally {
        this.baseSaving = false;
      }
    },
    normalizeConfigPayload() {
      return {
        id: this.channelId,
        close_time: this.configForm.close_time,
        open_reward_time: this.configForm.open_reward_time,
        max_ad: this.configForm.max_ad,
        amount_number: this.configForm.amount_number,
        recommend_number: this.configForm.recommend_number,
        apk_url: this.configForm.apk_url,
        template_type: this.configForm.template_type,
        is_open: this.configForm.is_open,
        splash_time: this.configForm.splash_time,
        open_time: this.configForm.open_time,
        login_type: Array.isArray(this.configForm.login_type)
          ? this.configForm.login_type.join("@")
          : "",
        open_withdraw: this.configForm.open_withdraw,
        withdraw_type: Array.isArray(this.configForm.withdraw_type)
          ? this.configForm.withdraw_type.join("@")
          : "",
        min_amount: this.configForm.min_amount,
        min_amount_num: this.configForm.min_amount_num,
        max_money: this.configForm.max_money,
        interstitial_time: this.configForm.interstitial_time,
        Interstitial_open: this.configForm.Interstitial_open,
        reward_pre_interstitial_open: this.configForm.reward_pre_interstitial_open,
        reward_post_interstitial_open: this.configForm.reward_post_interstitial_open,
        info_time: this.configForm.info_time,
        interstitial_num: this.configForm.interstitial_num,
      };
    },
    async saveConfig() {
      const valid = await new Promise((resolve) => {
        this.$refs.configFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.configSaving = true;
      try {
        const data = await this.$api.getChannel.saveChannelConfig(
          this.normalizeConfigPayload()
        );
        if (data.code === 200) {
          this.$message.success("渠道配置保存成功");
          await this.getInfo();
        }
      } finally {
        this.configSaving = false;
      }
    },
    handlePolicyTypeChange(policyType) {
      const meta = (this.policyOptionsMeta.form_schemas || {})[policyType] || {};
      this.policyForm.policy_config = mergePolicyDefaultConfig(
        meta.default_config || {},
        {}
      );
    },
    openPolicyDialog(policy) {
      this.editingPolicy = Boolean(policy && policy.id);
      const policyType = policy && policy.policy_type ? policy.policy_type : "";
      const meta = (this.policyOptionsMeta.form_schemas || {})[policyType] || {};
      this.policyForm = {
        ...defaultPolicyForm(this.channelId),
        ...(policy || {}),
        channel_id: this.channelId,
        policy_type: policyType,
        policy_config: mergePolicyDefaultConfig(
          meta.default_config || {},
          policy && policy.policy_config ? policy.policy_config : {}
        ),
      };
      this.policyDialogVisible = true;
    },
    resetPolicyDialog() {
      this.policyForm = defaultPolicyForm(this.channelId);
      this.editingPolicy = false;
      if (this.$refs.policyFormRef) {
        this.$refs.policyFormRef.resetFields();
      }
    },
    buildDynamicFieldRules(field) {
      return [
        {
          validator: (rule, value, callback) => {
            if (!shouldShowPolicyField(field, this.policyForm.policy_config)) {
              callback();
              return;
            }
            if (field.required && (value === undefined || value === null || value === "")) {
              callback(new Error(`请输入${field.label}`));
              return;
            }
            if (field.type === "number" && value !== undefined && value !== null && value !== "") {
              const numericValue = Number(value);
              if (Number.isNaN(numericValue)) {
                callback(new Error(`${field.label}必须是数字`));
                return;
              }
              if (field.min !== undefined && numericValue < field.min) {
                callback(new Error(`${field.label}不能小于${field.min}`));
                return;
              }
              if (field.max !== undefined && numericValue > field.max) {
                callback(new Error(`${field.label}不能大于${field.max}`));
                return;
              }
            }
            callback();
          },
          trigger: "change",
        },
      ];
    },
    normalizePolicyPayload() {
      const normalizedConfig = {};
      const sections = (this.currentPolicySchema && this.currentPolicySchema.sections) || [];
      sections.forEach((section) => {
        (section.fields || []).forEach((field) => {
          normalizedConfig[field.key] = normalizePolicyConfigValue(
            field,
            this.policyForm.policy_config[field.key]
          );
        });
      });

      return {
        id: this.policyForm.id,
        channel_id: this.channelId,
        policy_type: this.policyForm.policy_type,
        name: this.policyForm.name,
        enabled: this.policyForm.enabled,
        priority: this.policyForm.priority,
        remark: this.policyForm.remark,
        policy_config: normalizedConfig,
      };
    },
    async savePolicy() {
      const valid = await new Promise((resolve) => {
        this.$refs.policyFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.policySaving = true;
      try {
        const payload = this.normalizePolicyPayload();
        const data = this.editingPolicy
          ? await this.$api.getChannel.saveChannelRiskPolicy(payload)
          : await this.$api.getChannel.addChannelRiskPolicy(payload);
        if (data.code === 200) {
          this.$message.success(this.editingPolicy ? "策略更新成功" : "策略新增成功");
          this.policyDialogVisible = false;
          await this.getInfo();
        }
      } finally {
        this.policySaving = false;
      }
    },
    deletePolicy(policy) {
      this.$confirm(`确定删除策略“${policy.name}”吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const data = await this.$api.getChannel.deleteChannelRiskPolicy({
            id: policy.id,
          });
          if (data.code === 200) {
            this.$message.success("策略删除成功");
            await this.getInfo();
          }
        })
        .catch(() => {});
    },
  },
  async created() {
    await Promise.all([
      this.getPolicyOptions(),
      this.getTemplateOptions(),
    ]);
    await this.getInfo();
  },
};
</script>

<style lang="less" scoped>
.channel-detail-page {
  min-height: 420px;
}

.detail-header {
  margin-bottom: 18px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7fbff, #eef5ff);
  border: 1px solid #dde8f8;
}

.detail-header__main {
  h2 {
    margin: 0;
    color: #203864;
    font-size: 24px;
  }

  p {
    margin: 8px 0 0;
    color: #7a8da9;
  }
}

.detail-header__meta {
  display: flex;
  gap: 10px;
}

.detail-card {
  border-radius: 18px;
}

.detail-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.config-banner {
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fdf6ec;
  border: 1px solid #f3d19e;
  color: #a46c18;
  font-size: 13px;
}

.config-toolbar {
  margin-bottom: 18px;
  display: flex;
  justify-content: flex-end;
}

.copy-config-alert {
  margin-bottom: 18px;
}

.form-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.config-section {
  & + & {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px dashed #d9e4f3;
  }
}

.config-section__title,
.policy-section__title {
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #1f4ea0;
}

.template-option__desc {
  float: right;
  color: #8492a6;
  font-size: 12px;
}

.risk-task-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.risk-task-summary__card {
  padding: 16px;
  border-radius: 14px;
  background: #f7fbff;
  border: 1px solid #dde8f8;
}

.risk-task-summary__label {
  color: #6f84a8;
  font-size: 13px;
}

.risk-task-summary__value {
  margin-top: 10px;
  color: #203864;
  font-size: 17px;
  font-weight: 600;
  word-break: break-word;
}

.risk-task-summary__sub {
  margin-top: 10px;
  color: #7a8da9;
  font-size: 12px;
  line-height: 1.6;
}

.risk-task-toolbar {
  margin: 18px 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.risk-task-toolbar__hint {
  color: #6f84a8;
  font-size: 13px;
}

.policy-section {
  & + & {
    margin-top: 12px;
  }
}
</style>
